import React, { useEffect, useState, useContext } from 'react';
import {
  CircularProgress,
  Container,
  Typography,
  Card,
  CardContent,
  Stack,
  Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
  Chip,
  Alert
} from '@mui/material';
import { Edit } from '@mui/icons-material';
import contrattoApi from '../../api/contrattoApi';
import tipoContrattoApi from '../../api/tipocontrattoApi';
import { useParams, useNavigate } from 'react-router-dom';
import ProtectedAction from '../../components/ProtectedAction';
import BackButtonDesktop from '../../components/BackButtonDesktop';
import { AuthContext } from '../../auth/AuthContext';
import { formatDate } from '../../utils/dateFormatter';
import ConfirmDialog from '../../components/ConfirmDeleteModal';

const statoContrattoColor = {
  ATTIVO: 'success',
  IN_ATTESA_PAGAMENTO: 'warning',
  SCADUTO: 'default',
  ANNULLATO: 'error'
};

const pagamentoStatoColor = {
  CREATO: 'default',
  IN_ATTESA: 'warning',
  PAGATO: 'success',
  FALLITO: 'error'
};

const pagamentoMetodoLabel = {
  CARTA: 'Carta',
  BONIFICO: 'Bonifico',
  PAYPAL: 'PayPal'
};
const extractErrorMessage = (error) => {
  if (!error) return 'Errore sconosciuto';
  if (error.response?.data) return JSON.stringify(error.response?.data);
  if (!error.response) {
    return "L'elaborazione richiede più tempo del previsto. Riprova.";
  }
  return error.message || JSON.stringify(error);
};

export default function ContrattoDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [err, setErr] = useState(null);
  const [contratto, setContratto] = useState(null);
  const [tipoContratto, setTipoContratto] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openDelete, setOpenDelete] = useState(false);

useEffect(() => {
  const fetchContratto = async () => {
    setLoading(true);
    try {
      const r = await contrattoApi.get(id);
      setContratto(r.data);

      if (r.data.tipocontrattoId) {
        try {
          const t = await tipoContrattoApi.get(r.data.tipocontrattoId);
          setTipoContratto(t.data);
        } catch (err) {
          setErr(extractErrorMessage(err));
        }
      }
    } catch (err) {
      // Qui intercetti qualsiasi errore del controller
      const msg = extractErrorMessage(err);
      console.error("Errore fetch contratto:", msg);
      setErr(extractErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  fetchContratto();
}, [id]);

  const annullaContratto = async () => {
    if (!window.confirm('Annullare definitivamente il contratto?')) return;
    try {
      await contrattoApi.update(id, {
        ...form,
        dataAnnullamento: new Date().toISOString().substring(0, 10),
        attivo: false
      });
    } catch (e) {
      setErr(e.response?.data || e.message);
    }
  };

    const rinnova = async () => {
    setErr(null);
      //if (!window.confirm('Sei sicuro di voler rinnovare il contratto?')) return;
      try {
        await contrattoApi.renew(id);
        navigate(`/contratti/${id}`)
      } catch (e) {
        setErr(e.response?.data || e.message);
      } finally {
      }
    };

  if (loading) return <CircularProgress />;
  if (!contratto) return <div>Contratto non trovato</div>;

  if (contratto.id!=user?.contrattoId && user?.role!="ADMIN") return <div>Non puoi visualizzare questo dato</div>;

  const scaduto = new Date(contratto.dataFine) < new Date();

  return (
    <Container maxWidth="sm">
    <BackButtonDesktop />
      <Typography variant="h4" sx={{ mb: 2 }}>
        Dettaglio Contratto
      </Typography>

      {/* DATI CONTRATTO */}
      <Card>
        <CardContent>
          <Stack spacing={1}>
          <ProtectedAction user={user} roles={['ADMIN']}>
            <Typography>
              <strong>Utente:</strong>{' '}
              <Button
                size="small"
                onClick={() => navigate(`/users/${contratto.utenteId}`)}
              >
                Vai all’utente
              </Button>
            </Typography>
            </ProtectedAction>
            <Typography>
              <strong>Tipo contratto:</strong> {tipoContratto ? tipoContratto.tipo : '-'}
            </Typography>

            <Typography>
              <strong>Canone annuo:</strong> {contratto.canoneAnnuo} €
            </Typography>

            <Typography>
              <strong>Data inizio:</strong> {formatDate(contratto.dataInizio)}
            </Typography>

            <Typography>
              <strong>Data fine:</strong> {formatDate(contratto.dataFine)}
            </Typography>

            <Typography>
              <strong>Data annullamento:</strong> {contratto.dataAnnullamento || '-'}
            </Typography>

            <Chip
              label={contratto.stato || (scaduto ? 'SCADUTO' : 'ATTIVO')}
              color={statoContrattoColor[contratto.stato] || (scaduto ? 'warning' : 'success')}
              sx={{ width: 'fit-content', mt: 1 }}
            />
          </Stack>
        </CardContent>
      </Card>
    {err && <Alert severity="error" sx={{ mb: 2 }}>{err}</Alert>}
      {/* PAGAMENTI */}
            {/* AZIONI */}
            <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
                    {!scaduto && user.role === "ADMIN" && (
                      <Button
                        variant="contained"
                        color="warning"
                        onClick={rinnova}
                      >
                        Rinnova contratto
                      </Button>
                    )}
            </Stack>

      <Card sx={{ mt: 6 }}>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Pagamenti
          </Typography>

          {(!contratto.pagamenti || contratto.pagamenti.length === 0) && (
            <Typography color="text.secondary">
              Nessun pagamento presente
            </Typography>
          )}

          <Stack spacing={1}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Importo</TableCell>
                          <TableCell>Stato</TableCell>
                          <TableCell>Metodo</TableCell>
                          <TableCell>Data Pagamento</TableCell>
                          <TableCell>Azioni</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {contratto.pagamenti.map((p, idx) => (
                          <TableRow key={idx}>
                            <TableCell>{p.importo} €</TableCell>
                            <TableCell>{p.stato}</TableCell>
                            <TableCell>{p.metodo}</TableCell>
                            <TableCell>{p.dataPagamento || '-'}</TableCell>
                              <TableCell>
                                <Stack direction="row" spacing={1}>
                                  <IconButton color="secondary" size="small" onClick={() => navigate(`/pagamenti/edit/${p.id}`)}>
                                    <Edit />
                                  </IconButton>
                                </Stack>
                              </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
          </Stack>
        </CardContent>
      </Card>


    </Container>
  );
}
